<div class="app flex-row" style="margin-top: 100px">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-start display-3 me-4">500</h1>
          <h4 class="pt-3">Houston, we have a problem!</h4>
          <div class="text-muted">
            The page you are looking for is temporarily unavailable.
          </div>
          <div class="text-muted">
            <a [routerLink]="['/']">Click here</a> to go back to the dashboard
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
